import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TicketClose from '../../components/TicketClose'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { Link, useParams } from 'react-router-dom'
import Copyright from '../../components/common/Copyright'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { Box } from '@mui/material'

export default function TicketClosePage({ setBlockScreen }: any) {
  const { ticket_number } = useParams()

  return (<>
    <TopSideBar currentSection='tickets' disableProjectSelector />

    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs pathlist={[
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Home
          </Link>,
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Tickets
          </Link>,
          'Cerrar']}
        />
      </Box>


      <TitlebarAction
        title={`Cerrar Ticket: #${ticket_number}`}
      />

      <TicketClose
        ticket_number={ticket_number}
        setBlockScreen={setBlockScreen}
      />
      <Copyright />

    </PageContainer>
  </>)
}
